$(document).on("turbo:load turbo:render interests:added fieldsAdded", function(){
  var exclude = '.eos-tooltip';
  var tooltipSelector = '[data-bs-toggle="tooltip"]';
  var popoverSelector = '[data-bs-toggle="popover"]';
  var bs = window.bootstrap;

  if (bs && bs.Tooltip && bs.Popover) {
    $(tooltipSelector).not(exclude).each(function() {
      bs.Tooltip.getOrCreateInstance(this);
    });

    $(popoverSelector).each(function() {
      bs.Popover.getOrCreateInstance(this, {
        trigger: 'focus',
        container: 'body',
        html: true,
        placement: 'top'
      });
    });
  } else {
    // Fallback in case legacy jQuery bootstrap plugins are still active.
    if ($.fn.tooltip) {
      $(tooltipSelector).not(exclude).tooltip();
    }
    if ($.fn.popover) {
      $(popoverSelector).popover({
        trigger: 'focus',
        container: 'body',
        html: true,
        placement: 'top'
      });
    }
  }

  // TODO fix so modal only displays on successfully registering and first time to page.
  // var welcomeModal = $('#welcome');
  // var isWelcomeAvailable = welcomeModal.length;
  // if (isWelcomeAvailable) {
  //   welcomeModal.modal();
  // }

  var eosTooltip = $('.eos-tooltip');
  var isEosAvailable = eosTooltip.length;
  if (isEosAvailable) {
    if (bs && bs.Tooltip) {
      eosTooltip.each(function() {
        bs.Tooltip.getOrCreateInstance(this, {delay: {show: 500}});
      });
    } else if ($.fn.tooltip) {
      eosTooltip.tooltip({delay: {show: 500}});
    }
  }

  window.chooseRoles();
  window.erasePreScript();
});

window.chooseRoles = function() {
  var $doc = $(document);

  $doc.ready(function() {
    var checkboxes = $doc.find(".choose-role input");

    checkboxes.on('click', function(e) {
      $(this).closest('label').toggleClass('checked').hasClass('checked');
    });
  });
};

window.erasePreScript = function() {
  $(document).find('body.pre-script').removeClass('pre-script');
};

$.fn.select2.amd.define("CustomSelectionAdapter",
    [
        "select2/utils",
        "select2/options",
        "select2/selection/multiple",
        "select2/selection/placeholder",
        "select2/selection/eventRelay",
        "select2/selection/single",
        "select2/selection/allowClear",
        'select2/dropdown/attachBody'

    ],
    function (Utils, Options, MultipleSelection, Placeholder, EventRelay, SingleSelection, allowClear, AttachBody) {
        // Here goes the code of this custom adapter
        //Decorates MultipleSelection with Placeholder
        // let adapter = Utils.Decorate(SingleSelection, Options);
        // Decorates adapter with EventRelay - ensures events will continue to fire
        // e.g. selected, changed
        console.dir(allowClear);

        let adapter = Utils.Decorate(SingleSelection, Placeholder);
        adapter = Utils.Decorate(adapter, EventRelay);
        allowClear.prototype.update = function (decorated, data) {
            decorated.call(this, data);

            if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
                data.length === 0) {
                return;
            }

            var $remove = $(
                '<button type="button" class="btn-link blue-ghost select2-selection__clear">' +
                'clear' +
                '</button>'
            );
            $remove.data('data', data);
            $remove.on('keydown', function(e){
                this._handleClear(e)
            });

            this.$selection.find('.select2-selection__rendered').prepend($remove);
        };
        AttachBody.prototype._positionDropdown = function () {
            var $window = $(window);

            var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
            var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

            var newDirection = null;

            var offset = this.$container.offset();

            offset.bottom = offset.top + this.$container.outerHeight(false);

            var container = {
                height: this.$container.outerHeight(false)
            };

            container.top = offset.top;
            container.bottom = offset.top + container.height;

            var dropdown = {
                height: this.$dropdown.outerHeight(false)
            };

            var viewport = {
                top: $window.scrollTop(),
                bottom: $window.scrollTop() + $window.height()
            };

            var enoughRoomAbove = false;
            var enoughRoomBelow = true;

            var css = {
                left: offset.left,
                top: container.bottom
            };

            // Determine what the parent element is to use for calciulating the offset
            var $offsetParent = this.$dropdownParent;

            // For statically positoned elements, we need to get the element
            // that is determining the offset
            if ($offsetParent.css('position') === 'static') {
                $offsetParent = $offsetParent.offsetParent();
            }

            var parentOffset = $offsetParent.offset();

            css.top -= parentOffset.top;
            css.left -= parentOffset.left;

            if (!isCurrentlyAbove && !isCurrentlyBelow) {
                newDirection = 'below';
            }

            if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
                newDirection = 'above';
            } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
                newDirection = 'below';
            }

            if (newDirection == 'above' ||
                (isCurrentlyAbove && newDirection !== 'below')) {
                css.top = container.top - parentOffset.top - dropdown.height;
            }

            if (newDirection != null) {
                this.$dropdown
                    .removeClass('select2-dropdown--below select2-dropdown--above')
                    .addClass('select2-dropdown--' + newDirection);
                this.$container
                    .removeClass('select2-container--below select2-container--above')
                    .addClass('select2-container--' + newDirection);
            }

            this.$dropdownContainer.css(css);
        };
        adapter = Utils.Decorate(adapter, allowClear);

        return adapter;
    }

);

// run inputmask TODO: run inputmask for telephone placeholder
// $(":input").inputmask();
// $("#phone").inputmask({"mask": "(999) 999-9999"});